import axios from "axios";

const get = () => axios.get("api/v1/settings/functionality");

const add = (points) => axios.post("api/v1/settings", points);

const update = (list) => axios.put(`api/v1/settings/functionality`, { list });

const remove = (id) => axios.delete(`api/v1/settings/${id}`);

const ApiFunctionalityManagement = {
  get,
  add,
  update,
  remove,
};

export default ApiFunctionalityManagement;
